export default class ScaleLogic {
    static unitScaled(unit, scale) {
        const prefix = scale === 1e+12 ? "T" :
            scale === 1e+9 ? "G" :
                scale === 1e+6 ? "M" :
                    scale === 1e+3 ? "k" :
                        scale === 1e-3 ? "m" :
                            scale === 1e-6 ? "µ" :
                                "";
        return prefix + unit;
    }
    static preferredScale(value) {
        const absVal = Math.abs(value);
        return absVal >= 1e+12 ? 1e+12 :
            absVal >= 1e+9 ? 1e+9 :
                absVal >= 1e+6 ? 1e+6 :
                    absVal >= 1e+3 ? 1e+3 :
                        absVal < 1 ? 1e-3 :
                            absVal < 1e-3 ? 1e-6 :
                                1;
    }
    static valueScaled(value, scale) { return value / scale; }
    static formatScaledWithUnit(value, unit, scale) {
        return this.valueScaled(value, scale) + " " + this.unitScaled(unit, scale);
    }
}
